import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit } , model) {
        return new Promise((resolve, reject) => {
            ajax
              .get(`Credits/api/AccountsQuery/get_all_by_account_type?accountType=${model}`)
              .then((r) => {
                resolve(r.data);
              })
              .catch((e) => reject(e));
          });
    },
    
    fetchAttachment({ commit } , id) {
        return new Promise((resolve, reject) => {
            ajax
              .get(`Credits/api/PettyCashTransactionQuery/all-files/by/${id}`)
              .then((r) => {
                resolve(r.data);
              })
              .catch((e) => reject(e));
          });
    },
    async postAttachment({ commit, dispatch }, model) {
      return ajax
        .post("Credits/api/ExpenseAttachment", model)
        .then((r) => r)
        .catch((e) => console.log(e));
    },
    getAllLastLevelOfAccounts({ commit } ) {
      return new Promise((resolve, reject) => {
          ajax
            .get(`Credits/api/AccountsQuery/get_all-last-level-of-accounts`)
            .then((r) => {
              resolve(r.data);
            })
            .catch((e) => reject(e));
        });
  },
    getAllLastLevelOfFloatingAccounts({ commit } ,id) {
      return new Promise((resolve, reject) => {
          ajax
            .get(`Credits/api/FloatingAccountsQuery/get-all-accounts-by/${id}`)
            .then((r) => {
              resolve(r.data);
            })
            .catch((e) => reject(e));
        });
  },
    getAllLastLevelOfCostCenter({ commit } ,id) {
      return new Promise((resolve, reject) => {
          ajax
            .get(`Credits/api/CostCentersQuery/get-all-cost-centers-by/${id}`)
            .then((r) => {
              resolve(r.data);
            })
            .catch((e) => reject(e));
        });
  },
  fetchAllSubsideryAndDetailsAccount({ commit }) {
    return new Promise((resolve, reject) => {
        ajax
          .get(`Credits/api/AccountsQuery/get_all-subsidiary-and-detail-accounts`)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
},
  fetchVouchersArticle({ commit } ,id) {
      return new Promise((resolve, reject) => {
          ajax
            .get(`Credits/api/VouchersQuery/get-all-articles-by/${id}`)
            .then((r) => {
              resolve(r.data);
            })
            .catch((e) => reject(e));
        });
  },
  savePayment({ commit, dispatch }, model) {
    return ajax.post("Credits/api/Expense", model).then(() => {
      
    });
  },
  saveChargePettyCash({ commit, dispatch }, model) {
    return ajax.post("Credits/api/FundReplenishment", model).then(() => {
      
    });
  },
    fetchAllLastAccount({ commit } ) {
        return new Promise((resolve, reject) => {
            ajax
              .get(`Credits/api/FloatingAccountsQuery/get-all-last-level-accounts`)
              .then((r) => {
                resolve(r.data);
              })
              .catch((e) => reject(e));
          });
    },
    fetchAllLastAccountByName({ commit } , model) {
        return new Promise((resolve, reject) => {
            ajax
              .get(`Credits/api/FloatingAccountsQuery/get-all-last-level-accounts?accountType=${model}`)
              .then((r) => {
                resolve(r.data);
              })
              .catch((e) => reject(e));
          });
    },
    fetchAccount({ commit } , model) {
        return new Promise((resolve, reject) => {
            ajax
              .get(`/Credits/api/PartiesQuery?name=${model}`)
              .then((r) => {
                resolve(r.data);
              })
              .catch((e) => reject(e));
          });
    },
    fetchReportPettyCash({ commit } , params) {
        return new Promise((resolve, reject) => {
            ajax
              .get(`/Credits/api/VouchersQuery/report?${params}`)
              .then((r) => {
                resolve(r.data);
              })
              .catch((e) => reject(e));
          });
    },
    fetchPettyCash({ commit } ) {
        return new Promise((resolve, reject) => {
            ajax
              .get(`/Credits/api/PettyCashesQuery`)
              .then((r) => {
                resolve(r.data);
              })
              .catch((e) => reject(e));
          });
    },
    fetchPettyCashAccountInfo({ commit } ,id) {
        return new Promise((resolve, reject) => {
            ajax
              .get(`/Credits/api/PettyCashesQuery/get-all-accounts/${id}`)
              .then((r) => {
                resolve(r.data);
              })
              .catch((e) => reject(e));
          });
    },
    fetchPettyCashAccountInfoById({ commit } ,id) {
        return new Promise((resolve, reject) => {
            ajax
              .get(`/Credits/api/PettyCashesQuery/get-all-tiny-accounts/${id}`)
              .then((r) => {
                resolve(r.data);
              })
              .catch((e) => reject(e));
          });
    },
    fetchExpenseInfoById({ commit } ,id) {
        return new Promise((resolve, reject) => {
            ajax
              .get(`/Credits/api/PettyCashTransactionQuery/expense/details/by/${id}`)
              .then((r) => {
                resolve(r.data);
              })
              .catch((e) => reject(e));
          });
    },
    fetchCostTitle({ commit } ) {
        return new Promise((resolve, reject) => {
            ajax
              .get(`/Credits/api/CostTitleQuery`)
              .then((r) => {
                resolve(r.data);
              })
              .catch((e) => reject(e));
          });
    },
    fetchCostCenter({ commit } ) {
        return new Promise((resolve, reject) => {
            ajax
              .get(`/Credits/api/CostCentersQuery`)
              .then((r) => {
                resolve(r.data);
              })
              .catch((e) => reject(e));
          });
    },
    create({ commit, dispatch }, model) {
      return ajax.put("Credits/api/PettyCashes/assign-accounts_id", model).then(() => {
        
      });
    },
    confirmExpense({ commit, dispatch }, model) {
      return ajax.put("Credits/api/Expense/go-to-confrim", model).then(() => {
        
      });
    },
    createWithdrawal({ commit, dispatch }, model) {
      return ajax.post("Credits/api/Withdrawal", model).then(() => {
        
      });
    },
    createDeposit({ commit, dispatch }, model) {
      return ajax.post("Credits/api/Deposit", model).then(() => {
        
      });
    },
    
    createAccountParty({ commit, dispatch }, model) {
      return ajax.put("Credits/api/Parties/assign_costTitles", model).then(() => {
        
      });
    },
    
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
